<p>create-discussion works!</p>
